import { render, staticRenderFns } from "./AccountStatic.vue?vue&type=template&id=1756fe94&scoped=true"
import script from "./AccountStatic.vue?vue&type=script&lang=js"
export * from "./AccountStatic.vue?vue&type=script&lang=js"
import style0 from "./AccountStatic.vue?vue&type=style&index=0&id=1756fe94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1756fe94",
  null
  
)

export default component.exports